module.exports = __webpack_public_path__ + "static/img/缺省页.4b035a0a.png";